const Security = () => import('./pages/Security.vue')

const securityRoutes = [
  {
    path: 'security',
    name: 'security',
    component: Security,
    meta: {  requiresAuth: true, menuType: 'Profile' }
  }
]

export default securityRoutes